export const APIPath = {
  instagramPost: "/instagram",
  youtubeVideos: "/youtube",
  contacts: "/contacts/music",
};
